import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components/macro";
import Center from "./Center";

const StyledBackground = styled.div`
  width: 100vw;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;

  padding-top: 0.5em;
  padding-bottom: 2em;
  background-color: ${(props) => (props.background === "indigo" ? "var(--juno-color-brand)" : null)};
  background-color: ${(props) => (props.background === "grey" ? "var(--juno-color-pale-grey)" : null)};
  background-color: ${(props) => (props.background === "white" ? "var(--juno-color-white)" : null)};

  color: ${(props) => (props.background === "indigo" ? "var(--juno-color-text-reversed)" : null)};
  color: ${(props) => (props.background === "grey" ? "var(--juno-color-text)" : null)};
`;

function FullWidthBackground({ background = "indigo", pageWidth = "regular", className, children }) {
  return (
    <StyledBackground background={background} className={className}>
      <Center pageWidth={pageWidth}>{children}</Center>
    </StyledBackground>
  );
}

export default FullWidthBackground;

FullWidthBackground.propTypes = {
  background: PropTypes.oneOf(["indigo", "grey", "white"]),
  pageWidth: PropTypes.oneOf(["narrow", "regular", "wide", "wider"]),
};
